diy.angular.registerFactory('diyfmsectionmodel', [function() {

    // constructor
    var diyfmsectionmodel = function(id, title) {
        this._id = id;
        this._title = title;

        this._actions = [];
    };

    // public methods
    angular.extend(diyfmsectionmodel.prototype, {
        
        getId: function() {
            return this._id;
        },
        
        getTitle: function() {
            return this._title;
        },
        
        getActions: function() {
            return this._actions;
        },

        getSubsections: function() {
            return this._subsections;
        },

        addSubsection: function(subsection, index) {
            if (index === undefined) {
                this._subsections.push(subsection);
            } else {
                this._subsections.splice(index, 0, subsection);
            }
            // XXX we access a private property of subsection 
            // because we don't want to expose a public setSection there
            // because it will be confusing from where should be estabilish
            // this relationship
            subsection._section = this;
        },
        
        initializeSubsections: function(sources) {
            this._subsections = [];
        }
    });
    return diyfmsectionmodel;
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/models/diyfmsectionmodel.js
 ** module id = 960
 ** module chunks = 0
 **/